import { connect } from 'react-redux';
import { actionOnOrdercard, selectOrder, removeOrderFromSelection } from '../../reducers/order.reducers';
import OrderDialog from './order-dialog';

const mapStateToProps = state => ({
  open: !!state.orders.selectedOrder,
  order: state.orders.selectedOrder,
  orders: state.orders.selectedOrders,
});

const mapDispatchToProps = dispatch => ({
  proceedOrder: (order, description) => {
    dispatch(actionOnOrdercard({ order: order, proceeded: true, description: description }))
    dispatch(removeOrderFromSelection(order))
  },
  onClose: () => {
    dispatch(selectOrder(null))
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderDialog);
